import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {RoleInstitution} from "../../models/role-institution";
import Helpers from "../../utils/helpers";

@Injectable()
export class RoleInstitutionControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getRoleInstitutions(roleInstitutionId: string) {
    return this.http.get(this.baseUrl + "role_institution/" + roleInstitutionId);
  }

  public getRoleInstitutionList(roleId: string): Observable<RoleInstitution[]> {
    return this.http.get(this.baseUrl + "role/" + roleId + "/role_institution") as Observable<RoleInstitution[]>;
  }

  public saveRoleInstitution(roleInstitutionId: string, roleInstitution: RoleInstitution): Observable<RoleInstitution>  {
    Helpers.trimRecursiveObj(roleInstitution);
    const body = JSON.stringify(roleInstitution);
    return this.http.patch(this.baseUrl + "role_institution/" + roleInstitutionId, body) as Observable<RoleInstitution> ;
  }

  public createRoleInstitution(roleId: string, institutionId: string): Observable<RoleInstitution> {
    const body = institutionId;
    return this.http.post(this.baseUrl + "role/" + roleId + "/role_institution", body) as Observable<RoleInstitution>;
  }

  public deleteRoleInstitution(roleInstitutionId: string) {
    return this.http.delete(this.baseUrl + "role_institution/" + roleInstitutionId, {responseType: "text"});
  }

}
